import { Showroom } from '_app/types/api'

const DONT_SEND_RECEIPT_TEXT = 'Wyślij paragon mailem.'

export const addNoReceiptInfo = (
  customerComment: string | undefined,
  setComment: (comment: string) => void,
  sendMailReceipt: boolean
) => {
  const template = sendMailReceipt ? DONT_SEND_RECEIPT_TEXT : ''

  const comment = customerComment
    ? `###${template}${template ? ' ' : ''}Uwagi: ${customerComment.startsWith('###') ? customerComment.slice(3) : customerComment}`
    : `###${template}`
  setComment(comment)
}

const PARSE_STREET_REGEX = new RegExp(/([\d\s]*[\D]*)([\S\-\/]*)(.*)/)
export const parseShowroomAddress = (showroom: Showroom) => {
  const stringElems = (showroom.address || '')
    .split(',')
    .map(item => item.trim())

  const streetString = stringElems[stringElems.length - 1]
  const streetElements = (
    streetString.match(PARSE_STREET_REGEX)?.slice(1, 4) || ['', '', '']
  ).map(elem => elem.trim())
  const [street, streetNo, streetDetails] = streetElements

  return {
    street: [street, streetNo, streetDetails],
    postcode: stringElems[1],
    city: stringElems[0],
  }
}
